export default "__VITE_ASSET__1dfa292a__"